export default __webpack_public_path__ + "static/media/virtual-tour-slide-4-mobile.c7d7f243.png";